import { useCallback, useEffect } from "react";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useLexicalTextEntity } from "@lexical/react/useLexicalTextEntity";

import { $createCustomVariableNode, CustomVariableNode } from "../nodes/CustomVariableNode";

import type { TextNode } from "lexical";

type CustomVariableNodeProps = {
    prioritiziedRegexList: Array<RegExp>;
};

export default function CustomVariablesHighlightPlugin({
    prioritiziedRegexList,
}: CustomVariableNodeProps): JSX.Element | null {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (!editor.hasNodes([CustomVariableNode])) {
            throw new Error("CustomVariablesHighlightPlugin: CustomVariableNode not registered on editor");
        }
    }, [editor]);

    const createCustomVariableNode = useCallback((textNode: TextNode): CustomVariableNode => {
        return $createCustomVariableNode(textNode.getTextContent());
    }, []);

    const getKeywordMatch = useCallback(
        (text: string) => {
            // loop through prioritiziedRegexList to find the first match
            for (const wrap of prioritiziedRegexList) {
                const matchArr = wrap.exec(text);
                if (matchArr !== null) {
                    const startOffset = matchArr.index;
                    const endOffset = startOffset + matchArr[0].length;
                    return {
                        end: endOffset,
                        start: startOffset,
                    };
                }
            }
            return null;
        },
        [prioritiziedRegexList]
    );

    useLexicalTextEntity<CustomVariableNode>(getKeywordMatch, CustomVariableNode, createCustomVariableNode);

    return null;
}
